// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal___cd320"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 159
// module chunks = 0